module.exports = __webpack_public_path__ + "img/logo.cd7a4683.png";